import Script from "next/script";

export const SellwildDisplayAdsTag = () => {
  return (
    <Script
      async
      type="text/javascript"
      src="https://widget.sellwild.com/sellwild/sellwild-sellwild-next.js"
      id="sellwild-display-ads"
    />
  );
};
